export const de = {
  language: {
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
  },
  myApplications: {
    title: 'Meine Bewerbungen',
    archive: 'Archiv',
    archiveCount: 'Archiv ({{count}})',
    backToList: 'Zurück zu Meine Bewerbungen',
    archiveIntro:
      'Abgeschlossene und archivierte Bewerbungen. Schulen sehen nicht, was du archivierst.',
    filterLabel: 'Nach Status filtern',
    all: 'Alle',
    listLabel: 'Deine Bewerbungen',
    archiveListLabel: 'Archivierte Bewerbungen',
    loadFailed: 'Deine Bewerbungen konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    empty: {
      title: 'Noch keine Bewerbungen',
      text: 'Hier siehst du, wie es um deine Bewerbungen steht. Nichts Passendes dabei? Bewirb dich initiativ bei deiner Wunschschule.',
      jobs: 'Offene Stellen ansehen',
      schools: 'Schulen entdecken',
      archiveTitle: 'Archiv ist leer',
      archiveText:
        'Hier landen Bewerbungen, die du archivierst. Schulen sehen nicht, was du archivierst.',
      filtered: 'Keine Bewerbung mit diesem Status.',
    },
    menu: {
      label: 'Aktionen für {{title}}',
      posting: 'Stelleninserat ansehen',
      school: 'Schulprofil ansehen',
      withdraw: 'Bewerbung zurückziehen',
      archive: 'Archivieren',
      restore: 'Aus dem Archiv holen',
    },
    withdraw: {
      title: 'Bewerbung zurückziehen?',
      text: 'Du ziehst deine Bewerbung «{{title}}» bei {{school}} zurück. Die Schule sieht die Bewerbung mit dem Status «Zurückgezogen» und kann sie nicht mehr bearbeiten. Das lässt sich nicht rückgängig machen.',
      confirm: 'Bewerbung zurückziehen',
      cancel: 'Abbrechen',
      done: 'Bewerbung zurückgezogen.',
      failed:
        'Die Bewerbung konnte nicht zurückgezogen werden. Vielleicht hat die Schule sie inzwischen bearbeitet. Lade die Seite neu und versuche es nochmals.',
    },
    archived: 'Bewerbung archiviert.',
    restored: 'Bewerbung zurück in Meine Bewerbungen.',
    archiveFailed: 'Das hat nicht geklappt. Bitte versuche es nochmals.',
  },
  installHint: {
    close: 'Hinweis schliessen',
    install: 'App installieren',
    applications: {
      title: 'Antworten der Schule sofort aufs Handy',
      text: 'Hol dir Bildigsnetz auf den Home-Bildschirm. So bekommst du eine Push-Nachricht, sobald eine Schule antwortet.',
    },
    home: {
      title: 'Bildigsnetz als App aufs Handy',
      text: 'Hol dir Bildigsnetz auf den Home-Bildschirm. So bekommst du Nachrichten und Antworten sofort als Push-Nachricht.',
    },
    sheet: {
      title: 'Bildigsnetz auf den Home-Bildschirm',
      ok: 'Verstanden',
      ios: {
        '1': 'Tippe in Safari unten auf «Teilen».',
        '2': 'Wähle «Zum Home-Bildschirm».',
        '3': 'Öffne Bildigsnetz dort und schalte Push ein.',
      },
      android: {
        '1': 'Tippe im Browser oben rechts auf das Menü.',
        '2': 'Wähle «App installieren» oder «Zum Startbildschirm hinzufügen».',
        '3': 'Öffne Bildigsnetz dort und schalte Push ein.',
      },
    },
  },
  applicationDetail: {
    head: 'Deine Bewerbung vom {{date}}',
    headInitiative: 'Deine Initiativbewerbung vom {{date}}',
    status: 'Status',
    progress: 'Fortschritt deiner Bewerbung',
    since: 'seit {{date}}',
    pending: 'ausstehend',
    step: {
      sent: 'Gesendet',
      review: 'In Prüfung',
      interview: 'Gespräch',
      decision: 'Entscheid',
      answer: 'Antwort der Schule',
      accepted: 'Zugesagt',
      rejected: 'Abgesagt',
      withdrawn: 'Zurückgezogen',
    },
    state: {
      done: '(erledigt)',
      now: '(aktueller Schritt)',
      todo: '(offen)',
      yes: '(Zusage)',
      no: '(abgeschlossen)',
    },
    text: {
      PENDING:
        'Die Schule prüft deine Bewerbung. Du bekommst eine E-Mail, sobald sich der Status ändert.',
      PENDING_INITIATIVE:
        'Die Schule hat deine Initiativbewerbung erhalten und meldet sich bei dir.',
      INVITED:
        'Die Schule möchte dich kennenlernen. Die Einladung findest du im Chat und in deinen E-Mails.',
      ACCEPTED:
        'Herzlichen Glückwunsch! Die Schule hat dir zugesagt. Die nächsten Schritte bespricht sie direkt mit dir, die Nachricht findest du im Chat und in deinen E-Mails.',
      REJECTED:
        'Die Schule hat sich für eine andere Person entschieden. Ihre Nachricht findest du im Chat und in deinen E-Mails. Viel Erfolg bei deiner weiteren Suche!',
      WITHDRAWN:
        'Du hast diese Bewerbung zurückgezogen. Die Schule bearbeitet sie nicht mehr.',
    },
    withdraw: 'Bewerbung zurückziehen',
    withdrawInitiative: 'Initiativbewerbung zurückziehen',
    posting: 'Stellenbeschreibung',
    schoolProfile: 'Schulprofil',
    authorityProfile: 'Schulgemeindeprofil',
    letter: 'Nachricht an die Schule',
    letterReviewer: 'Nachricht an Schule / Bewerbungsschreiben',
    attachments: 'Anhänge',
    cv: 'Lebenslauf',
    tandemCv: '2. Lebenslauf bei Tandem-Bewerbung',
    qualifications: 'Diplome und Zertifikate',
    additionalDocs: 'Arbeitszeugnisse und Weiteres',
    view: 'Anzeigen',
  },
  jobArchive: {
    rejectAll: 'Allen {{count}} offenen Bewerbungen absagen',
    rejectAllHint:
      'Nach dem Archivieren öffnet sich die Absage mit Standardtext. Du kannst sie vor dem Senden anpassen.',
    tooMany:
      'Mehr als {{max}} offene Bewerbungen: Sag bitte in der Bewerbungsübersicht in Gruppen von höchstens {{max}} ab.',
  },
  settings: {
    title: 'Einstellungen',
    crumb: 'Deine Einstellungen',
    back: 'Zurück',
    save: 'Speichern',
    change: 'Ändern',
    next: 'Weiter',
    cancel: 'Abbrechen',
    failed: 'Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.',
    currentPassword: 'Aktuelles Passwort',
    forgotPassword: 'Passwort vergessen?',
    tile: {
      account: 'Nutzerkonto',
      accountSub: 'Zugangsdaten und persönliche Einstellungen',
      privacy: 'Privatsphäre',
      privacySub: 'Hier bestimmst du, welche deiner Angaben sichtbar sind',
      notifications: 'Benachrichtigungen',
      notificationsSub: 'Benachrichtigungen per E-Mail und Stellen-Vorschläge',
      subscription: 'Abonnement',
      subscriptionSub: 'Verwalte hier deine Abo-Einstellungen',
    },
    account: {
      access: 'Zugangsdaten',
      contact: 'Kontaktdaten',
      contactSub: 'Wohnort und Telefonnummer',
      contactSubEmail: 'Wohnort, E-Mail und Telefonnummer',
      password: 'Passwort ändern',
      personal: 'Persönliche Einstellungen',
      name: 'Name ändern',
      delete: 'Profil löschen',
      deleteSub: 'Möchtest du Bildigsnetz nicht mehr nutzen?',
    },
    name: {
      crumb: 'Name',
      intro:
        'Deine persönlichen Daten sind die Basis deines Bildigsnetz-Profils. Falls du hier Änderungen vornimmst, werden diese von uns geprüft und manuell freigeschaltet.',
      info: 'Wichtige Hinweise zum Namen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      reason: 'Änderungsgrund',
      saved: 'Name geändert.',
      rulesTitle: 'Für deinen Namen gibt es zwei Regeln:',
      rule1:
        '1. Gib Vorname und Nachname vollständig ein (z. B. «Max» / «Meier», nicht «M.» / «Meier»).',
      rule2:
        '2. Gib deinen echten Namen ein (nicht «Bibi Blocksberg» oder «James Bond»).',
      action: 'Namen ändern',
    },
    email: {
      title: 'E-Mail-Adresse ändern',
      intro:
        'Hier kannst du die E-Mail-Adresse ändern, mit der du dich einloggst und an die wir dir Benachrichtigungen senden.',
      current: 'Deine aktuelle E-Mail-Adresse',
      edulog:
        'Du meldest dich über Edulog an. Wenn du deine E-Mail-Adresse ändern möchtest, wende dich bitte an unseren',
      support: 'Support',
      new: 'Neue E-Mail-Adresse',
      invalid: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      sentTitle: 'Änderung der E-Mail-Adresse beantragt',
      sentText:
        'Wir haben dir einen Link an {{email}} geschickt. Klicke darauf, um die neue Adresse zu bestätigen. Danach meldest du dich mit der neuen Adresse an. Bis dahin gilt deine bisherige Adresse.',
    },
    password: {
      title: 'Passwort ändern',
      intro:
        'Leg hier das neue Passwort fest, mit dem du dich bei Bildigsnetz einloggst.',
      saved: 'Passwort aktualisiert.',
      resetSent: 'Wir senden dir eine E-Mail an deine E-Mail-Adresse:',
      resetHint:
        'Klicke auf den Link in der E-Mail, um dein Passwort zu ändern.',
    },
    delete: {
      title: 'Profil löschen',
      intro:
        'Schade, dass du Bildigsnetz nicht mehr nutzen möchtest. Du bist ein wichtiger Teil des Schweizer Bildungssystems und wir würden dich gerne behalten. Beachte bitte, dass wir deine Profildaten wirklich löschen. Das kann also nicht rückgängig gemacht werden.',
      ownerTitle: 'Zuerst die Hauptverantwortung übergeben',
      ownerText:
        'Du bist Besitzer:in der folgenden Organisationen. Damit sie nicht ohne verantwortliche Person zurückbleiben, übergib die Hauptverantwortung an eine:n andere:n Super Admin, bevor du dein Profil löschst.',
      toTeam: 'Zu Team & Berechtigungen',
      blocked: 'Löschen nicht möglich',
      deleting: 'Profil wird gelöscht …',
      confirm: 'Es tut uns leid, dich als Mitglied zu verlieren.',
      deleted: 'Profil wurde gelöscht.',
      failed:
        'Das Profil konnte nicht gelöscht werden. Bitte versuche es später erneut.',
    },
    privacy: {
      title: 'Privatsphäre',
      analytics: 'Analytics und Tracking',
      analyticsText:
        'Diese Cookies ermöglichen uns zu verstehen, wie du unsere Website nutzt, damit wir sie gezielt optimieren können.',
      saved: 'Privatsphäre aktualisiert.',
    },
    contact: {
      title: 'Kontaktdaten',
      email: 'E-Mail',
      changeEmail: 'E-Mail-Adresse ändern?',
      phone: 'Telefonnummer',
      saved: 'Kontaktdaten gespeichert.',
    },
    notifications: {
      title: 'Benachrichtigungen per E-Mail',
      newsletter:
        'Gerne möchte ich wichtige Informationen im Newsletter erhalten',
      chat: 'Benachrichtigung, wenn ich eine Chatnachricht erhalte',
      alwaysOn: 'Immer aktiv',
      saved: 'E-Mail-Einstellungen aktualisiert.',
      section: {
        team: 'Schulprofil & Team',
        hr: 'HR-Prozesse',
        admin: 'Administrator-Änderungen',
        account: 'Konto',
      },
      item: {
        member_joined: {
          label: 'Neues Teammitglied',
          description:
            'Wenn eine Person deiner Schule oder Schulgemeinde als Mitglied beitritt.',
        },
        member_left: {
          label: 'Teammitglied ausgetreten',
          description:
            'Wenn ein Mitglied deine Schule oder Schulgemeinde verlässt.',
        },
        member_removed: {
          label: 'Aus einem Team entfernt',
          description:
            'Wenn dich eine Administratorin oder ein Administrator aus einem Team entfernt.',
        },
        application_received: {
          label: 'Neue Bewerbung',
          description:
            'Wenn eine neue Bewerbung auf eine deiner Stellen eingeht.',
        },
        application_withdrawn: {
          label: 'Bewerbung zurückgezogen',
          description:
            'Wenn eine Bewerberin oder ein Bewerber eine Bewerbung zurückzieht.',
        },
        application_confirmation_copy: {
          label: 'Kopie der Eingangsbestätigung',
          description:
            'Eine Kopie der Eingangsbestätigung, die an Bewerbende versendet wird.',
        },
        job_runtime_ending: {
          label: 'Schaltdauer endet',
          description:
            'Wenn die Schaltdauer einer Stellenausschreibung bald endet.',
        },
        admin_added: {
          label: 'Administratorrechte erhalten (Schule)',
          description: 'Wenn du Administratorrechte für eine Schule erhältst.',
        },
        admin_revoked: {
          label: 'Administratorrechte entzogen (Schule)',
          description:
            'Wenn dir Administratorrechte für eine Schule entzogen werden.',
        },
        authority_admin_added: {
          label: 'Administratorrechte erhalten (Schulgemeinde)',
          description:
            'Wenn du Administratorrechte für eine Schulgemeinde erhältst.',
        },
        authority_admin_revoked: {
          label: 'Administratorrechte entzogen (Schulgemeinde)',
          description:
            'Wenn dir Administratorrechte für eine Schulgemeinde entzogen werden.',
        },
        account_deleted: {
          label: 'Konto gelöscht',
          description: 'Bestätigung, wenn dein Konto gelöscht wurde.',
        },
      },
    },
    push: {
      title: 'Mitteilungen auf diesem Gerät',
      intro:
        'Bei neuen Chatnachrichten und Bewerbungen erscheint eine Mitteilung und eine Zahl auf dem App-Symbol, auch wenn Bildigsnetz geschlossen ist.',
      active: 'Auf diesem Gerät aktiv',
      off: 'Ausschalten',
      enable: 'Mitteilungen aktivieren',
      needsInstall:
        'Auf iPhone und iPad funktionieren Mitteilungen nur, wenn Bildigsnetz auf dem Home-Bildschirm liegt: Im Browser auf das Teilen-Symbol tippen und «Zum Home-Bildschirm» wählen. Danach Bildigsnetz über das neue Symbol öffnen und hier aktivieren.',
      denied:
        'Mitteilungen sind für Bildigsnetz blockiert. Du kannst sie in den Einstellungen deines Browsers oder Geräts erlauben und die Seite danach neu laden.',
      unavailable: 'Mitteilungen sind noch nicht freigeschaltet.',
      unsupported: 'Dieser Browser unterstützt keine Mitteilungen.',
      error: 'Das hat nicht geklappt. Bitte versuche es nochmals.',
      retry: 'Nochmals versuchen',
    },
    templates: {
      settings: 'Deine Einstellungen',
      title: 'Vorlagen',
      tile: 'Vorlagen',
      tileSub:
        'Eigene Texte und Vorlagen der Schule für Einladungen, Zusagen und Absagen',
      tab: {
        PERSONAL: 'Meine Vorlagen',
        SCHOOL: 'Vorlagen der Schule',
      },
      intro: {
        PERSONAL:
          'Deine persönlichen Texte. Pro Art bis zu 3, nur du siehst sie. Neue Vorlagen speicherst du direkt beim Schreiben mit «Als Vorlage speichern».',
        SCHOOL:
          'Texte für alle in der Schule. Pro Art bis zu 3. Alle mit Schreibrechten können sie verwenden, ändern dürfen sie nur Besitzer, Admin und HR.',
      },
      org: 'Schule',
      noOrg:
        'Du gehörst zu keiner Schule. Vorlagen der Schule gibt es nur für Mitarbeitende einer Schule.',
      count: '{{count}} von {{max}}',
      empty: {
        PERSONAL:
          'Noch keine eigene Vorlage. Schreib eine {{kind}}, passe den Text an und wähle «Als Vorlage speichern».',
        SCHOOL:
          'Noch keine Vorlage der Schule für diese Art. Speichere beim Schreiben einer {{kind}} mit «Ganze Schule».',
      },
      subject: 'Betreff',
      savedAt: 'Gespeichert {{date}}',
      name: 'Name der Vorlage',
      placeholders:
        'Platzhalter: {vorname}, {nachname}, {stelle}, {absender}, {schule}',
      edit: 'Bearbeiten',
      editLabel: 'Vorlage {{name}} bearbeiten',
      deleteLabel: 'Vorlage {{name}} löschen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      deleteTitle: 'Vorlage «{{name}}» löschen?',
      deleteText:
        'Die Vorlage verschwindet aus «Meine Vorlagen». Bereits gesendete Nachrichten bleiben unverändert.',
      deleteTextSchool:
        'Die Vorlage verschwindet für alle in der Schule. Bereits gesendete Nachrichten bleiben unverändert.',
      saved: 'Vorlage gespeichert.',
      deleted: 'Vorlage gelöscht.',
      forbidden:
        'Vorlagen der Schule können nur Besitzer, Admin und HR ändern.',
      failed: 'Das hat nicht geklappt. Bitte versuche es nochmals.',
      loadFailed: 'Die Vorlagen konnten nicht geladen werden.',
      retry: 'Nochmals versuchen',
      footer:
        'Beim Löschen fragt Bildigsnetz nach. Die Standardvorlagen von Bildigsnetz bleiben immer verfügbar.',
    },
    language: {
      title: 'Sprache',
      hint: 'Gilt für die App und alle E-Mails von Bildigsnetz',
      saved: 'Sprache gespeichert',
      failed:
        'Die Sprache konnte nicht gespeichert werden. Bitte versuche es noch einmal.',
    },
  },
  login: {
    title: 'Hallo!',
    intro:
      'Mit deinem Konto erhältst du Zugang zu den Fachkräfteprofilen und allen Möglichkeiten von Bildigsnetz.',
    email: 'E-Mail',
    password: 'Passwort',
    passwordRequired: 'Bitte gib dein Passwort ein.',
    submit: 'Einloggen',
    edulog: 'Einloggen mit Edulog',
    google: 'Einloggen mit Google',
    noAccount: 'Noch kein Konto?',
    signup: 'Registrieren',
    forgotPassword: 'Passwort vergessen?',
    error: {
      credentials: 'Deine E-Mail-Adresse oder das Passwort ist ungültig.',
      tooManyRequests:
        'Zu viele Versuche. Bitte warte ein paar Minuten und versuche es dann erneut.',
      offline:
        'Keine Verbindung. Bitte prüfe deine Internetverbindung und versuche es erneut.',
      server:
        'Deine Zugangsdaten stimmen, aber wir konnten dein Profil gerade nicht laden. Bitte versuche es in ein paar Minuten erneut.',
    },
  },
  authError: {
    otherProvider:
      'Dein Konto ist bereits mit einer anderen Anmeldeart verbunden (z. B. Google oder E-Mail).',
    emailInUse: 'Die E-Mail-Adresse wird bereits verwendet.',
    invalidEmail: 'Die E-Mail-Adresse ist ungültig.',
    wrongPassword: 'Das Passwort ist falsch.',
    tooManyRequests:
      'Zu viele Versuche. Bitte warte ein paar Minuten und versuche es dann erneut.',
    offline:
      'Keine Verbindung. Bitte prüfe deine Internetverbindung und versuche es erneut.',
    userDisabled: 'Dieses Konto ist gesperrt. Bitte melde dich beim Support.',
    unknown: 'Es ist ein Fehler aufgetreten.',
  },
  signup: {
    title: 'Registriere dich kostenlos',
    subtitle: 'Dein Profil ist in einer Minute erstellt.',
    email: 'E-Mail',
    emailPlaceholder: 'name@beispiel.ch',
    emailInvalid: 'E-Mail-Adresse ist ungültig.',
    emailRequired: 'E-Mail-Adresse ist erforderlich.',
    password: 'Passwort',
    passwordHelp: 'Was macht ein sicheres Passwort aus?',
    passwordHint:
      'Mindestens 8 Zeichen, mit Gross- und Kleinbuchstaben und einer Zahl.',
    passwordRequired: 'Bitte gib ein Passwort ein.',
    passwordWeak:
      'Das Passwort ist zu schwach: mindestens 8 Zeichen, mit Gross- und Kleinbuchstaben und einer Zahl.',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    newsletter: 'Ich möchte den Newsletter erhalten',
    termsBefore: 'Mit der Registrierung stimmst du den',
    terms: 'AGB',
    termsBetween: ', der',
    privacy: 'Datenschutzerklärung',
    termsAnd: 'und der',
    cookies: 'Cookie-Richtlinie',
    termsAfter: ' zu.',
    submit: 'Konto erstellen',
    or: 'oder',
    edulog: 'Mit Edulog registrieren',
    google: 'Mit Google registrieren',
    haveAccount: 'Bereits ein Konto?',
    login: 'Anmelden',
    error: 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.',
    benefitsTitle: 'Deine Vorteile mit einem Profil',
    benefits: {
      apply: {
        title: 'In wenigen Klicks bewerben',
        text: 'Unterlagen einmal speichern und für jede Bewerbung wiederverwenden.',
      },
      chat: {
        title: 'Direkt chatten',
        text: 'Unkompliziert mit Schulen und anderen Fachkräften schreiben.',
      },
      push: {
        title: 'Push aufs Handy',
        text: 'Antworten von Schulen und neue Stellen sofort aufs Handy, mit Bildigsnetz auf dem Home-Bildschirm.',
      },
      searchAgent: {
        title: 'Persönliches Suchabo',
        text: 'Neue passende Stellen automatisch per E-Mail erhalten.',
      },
      applications: {
        title: 'Bewerbungen verwalten',
        text: 'Alle Bewerbungen und ihren Status an einem Ort.',
      },
      profile: {
        title: 'Berufsprofil',
        text: 'Zeig deine Stärken und erhalte Anfragen von Schulen.',
      },
      network: {
        title: 'Vernetzung',
        text: 'Fachkräfte entdecken und Hospitationsmöglichkeiten finden.',
      },
    },
  },
  receivedApplications: {
    backToJobs: 'Zurück zu Inserate & Bewerbungen',
    title: 'Bewerbungsübersicht',
    tileHint: 'Status anklicken, um zu filtern',
    filterByStatus: 'Nach Status filtern',
    toolbar: 'Ansicht anpassen',
    search: 'Name oder E-Mail suchen',
    status: {
      ALL: 'Alle',
      PENDING: 'In Prüfung',
      INVITED: 'Eingeladen',
      ACCEPTED: 'Zugesagt',
      REJECTED: 'Abgesagt',
      WITHDRAWN: 'Zurückgezogen',
    },
    sort: {
      label: 'Sortierung',
      NEWEST: 'Eingang, neueste zuerst',
      OLDEST: 'Eingang, älteste zuerst',
      RATING: 'Bewertung',
      NAME: 'Name A bis Z',
    },
    filter: {
      label: 'Filter',
      rating: 'Bewertung',
      unrated: 'Noch nicht bewertet',
      membership: 'Mitgliedschaft',
      MEMBER: 'Nur Mitglieder',
      GUEST: 'Ohne Konto',
      period: 'Eingang',
      periodALL: 'Alle Daten',
      period7: 'Letzte 7 Tage',
      period30: 'Letzte 30 Tage',
      reset: 'Zurücksetzen',
      close: 'Fertig',
    },
    view: {
      label: 'Ansicht',
      cards: 'Kartenansicht',
      list: 'Listenansicht',
    },
    rating: {
      label: 'Bewertung',
      set: 'Bewertung {{rating}}',
      current: 'Bewertung {{rating}}',
      none: 'Noch nicht bewertet',
      change: 'ändern',
      remove: 'Bewertung entfernen',
      failed: 'Die Bewertung konnte nicht gespeichert werden.',
    },
    selection: {
      label: 'Auswahl',
      count: '{{count}} ausgewählt',
      clear: 'Auswahl aufheben',
    },
    readOnly: {
      title: 'Du hast Lesezugriff.',
      text: 'Du siehst Bewerbungen und Bewertungen. Ändern kann nur, wer Schreibrechte hat.',
    },
    empty: {
      title: 'Noch keine Bewerbungen',
      job: 'Sobald sich jemand bewirbt, erscheint die Karte unter «In Prüfung». Du bekommst dazu eine E-Mail.',
      initiative: 'Hier erscheinen Bewerbungen ohne konkrete Stelle.',
    },
    noMatch: 'Keine Bewerbung passt zu Suche oder Filter.',
    loadFailed: 'Die Bewerbungen konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    jobLoadFailed: 'Das Inserat konnte nicht geladen werden.',
    showMore: '{{count}} weitere anzeigen',
    conflict:
      'Jemand hat die Bewerbung gerade geändert. Die Übersicht ist jetzt aktuell.',
    changeDenied: 'Du hast nur Lesezugriff auf diese Bewerbung.',
    emptyColumn: 'Keine Bewerbungen',
    dragHint:
      'Karte in eine andere Spalte ziehen ändert nur den Status, ohne Nachricht. Ohne Maus: Status im Dossier ändern.',
    emptyWithdrawn: 'Nur die Bewerbenden selbst können zurückziehen.',
    expand: 'Spalte {{status}} mit {{count}} Bewerbungen aufklappen',
    collapse: 'Spalte {{status}} zuklappen',
    select: '{{name}} auswählen',
    selectAll: 'Alle Bewerbungen in {{status}} auswählen',
    new: 'Neu',
    member: 'Mitglied',
    guest: 'Kein Mitglied',
    applied: 'Eingang',
    phone: 'Telefon',
    mail: 'Mail',
    mailTo: 'Mail an {{name}}',
    dossier: {
      back: 'Zurück zur Übersicht',
      jobs: 'Inserate & Bewerbungen',
      loading: 'Bewerbung wird geladen …',
      loadFailed: 'Die Bewerbung konnte nicht geladen werden.',
      accessDenied: {
        title: 'Kein Zugriff auf diese Bewerbung',
        text: 'Deine Rolle an dieser Schule erlaubt keinen Einblick in Bewerbungen. Wende dich an den Besitzer oder einen Admin der Schule.',
      },
      readOnly:
        'Du siehst das Dossier und kannst Unterlagen herunterladen. Ändern kann nur, wer Schreibrechte hat.',
      appliedFor: 'Bewerbung auf',
      status: 'Status',
      statusFailed: 'Der Status konnte nicht geändert werden.',
      contact: 'Kontakt',
      profile: 'Profil ansehen',
      guestHint:
        'Gastbewerbung: kein Profil und kein Chat. Erreichbar per Mail oder Telefon.',
      letterAndDocuments: 'Bewerbungsschreiben und Unterlagen',
      downloadAll: 'Ganzes Dossier herunterladen',
      downloading: 'Dossier wird erstellt …',
      downloadFailed:
        'Das Dossier konnte nicht heruntergeladen werden. Bitte versuche es nochmals.',
      zipName: 'Bewerbungsdossier',
      noLetter: 'Kein Bewerbungsschreiben.',
      documents: 'Unterlagen',
      docs: {
        cv: 'Lebenslauf',
        tandemCv: 'Lebenslauf Jobsharing-Partner:in',
        diplomas: 'Diplome und Zertifikate',
        references: 'Arbeitszeugnisse und Referenzen',
      },
      noFile: 'Keine Datei',
      download: '{{name}} herunterladen',
      open: '{{name}} öffnen',
      ratingHint:
        'Die Bewertung gilt für das ganze Team und ist nur intern sichtbar.',
      notes: {
        title: 'Notizen',
        empty: 'Noch keine Notizen.',
        add: 'Neue Notiz',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        save: 'Speichern',
        cancel: 'Abbrechen',
        hint: 'Notizen sehen alle, die diese Bewerbung sehen dürfen. Die Person selbst sieht sie nie.',
        failed: 'Die Notiz konnte nicht gespeichert werden.',
        deleteTitle: 'Notiz löschen?',
        deleteText:
          'Die Notiz wird für alle gelöscht und lässt sich nicht wiederherstellen.',
        discardTitle: 'Notiz verwerfen?',
        discardText:
          'Deine Notiz ist noch nicht gespeichert und geht verloren.',
        keepEditing: 'Weiter bearbeiten',
      },
      messages: {
        loadFailed: 'Die Nachrichten konnten nicht geladen werden.',
        title: 'Nachrichten',
        empty: 'Noch keine Nachrichten gesendet.',
        by: 'von {{name}}',
        retry: 'Erneut senden',
        retried: 'Wird erneut gesendet.',
        retryFailed: 'Erneutes Senden fehlgeschlagen.',
        kind: {
          MESSAGE: 'Nachricht',
          INVITATION: 'Einladung',
          ACCEPTANCE: 'Zusage',
          REJECTION: 'Absage',
        },
        channel: {
          CHAT: 'Chat',
          EMAIL: 'E-Mail',
        },
        state: {
          PENDING: 'wird gesendet',
          SENDING: 'wird gesendet',
          ACCEPTED: 'gesendet',
          DELIVERED: 'zugestellt',
          FAILED: 'fehlgeschlagen',
          BOUNCED: 'nicht zustellbar',
        },
      },
      history: {
        title: 'Verlauf',
        someone: 'Jemand',
        submitted: 'Bewerbung eingegangen',
        status: '{{name}} hat den Status auf «{{status}}» gesetzt',
        rated: '{{name}} hat mit {{rating}} bewertet',
        unrated: '{{name}} hat die Bewertung entfernt',
        viewed: '{{name}} hat die Bewerbung geöffnet',
        claimed: 'Gast hat ein Konto erstellt',
      },
    },
    compose: {
      close: 'Schliessen',
      cancel: 'Abbrechen',
      backToMessage: 'Zurück zur Nachricht',
      toOne: 'An {{name}}',
      toMany: 'An {{count}} Personen',
      initiative: 'Initiativbewerbung',
      kindLabel: 'Art der Nachricht',
      from: 'Von',
      via: 'via Bildigsnetz',
      replyTo: 'noreply@bildigsnetz.ch · Antworten gehen an {{email}}',
      copyToMe: 'Kopie an mich senden',
      to: 'An',
      ownMail: 'jede Person erhält eine eigene E-Mail',
      channel: {
        label: 'Senden über',
        CHAT_AND_EMAIL: 'Chat und E-Mail',
        CHAT_AND_EMAIL_sub: 'Nachricht im Chat, E-Mail als Hinweis',
        EMAIL_ONLY: 'Nur E-Mail',
        EMAIL_ONLY_sub: 'Wie bei Personen ohne Profil',
        mixed:
          '{{members}} von {{total}} Personen sind Mitglied. Die anderen erhalten die Nachricht nur per E-Mail.',
      },
      guestOne:
        '{{name}} ist kein Bildigsnetz-Mitglied und erhält die Nachricht per E-Mail.',
      guestMany:
        'Niemand davon ist Bildigsnetz-Mitglied. Alle erhalten die Nachricht per E-Mail.',
      languageOther:
        'Standardvorlagen auf {{language}}, in der Sprache der Bewerbung.',
      languageNames: { de: 'Deutsch', fr: 'Französisch', it: 'Italienisch' },
      languageMixed:
        'Die Bewerbungen sind in verschiedenen Sprachen. Eine unveränderte Standardvorlage erhält jede Person in ihrer Sprache.',
      templates: {
        own: 'Meine Vorlagen',
        school: 'Vorlagen der Schule',
        standard: 'Standardvorlagen',
        count: '{{count}} von 3',
        noneOwn:
          'noch keine. Passe einen Text an und speichere ihn unten mit «Als Vorlage speichern».',
      },
      subject: 'Betreff',
      body: 'Nachricht',
      hintOne: 'Anpassbar. {schule} wird beim Senden ersetzt.',
      hintMany:
        'Anpassbar. {vorname} und {nachname} werden pro Person ersetzt.',
      statusNote:
        'Nach dem Senden wechselt der Status auf «{{status}}». Vorher ändert sich nichts.',
      statusNoteMany:
        'Nach dem Senden wechselt der Status aller {{count}} Personen auf «{{status}}». Vorher ändert sich nichts.',
      quickNote: 'Wird sofort gesendet. Der Status wechselt auf «{{status}}».',
      sentOne: 'Nachricht gesendet.',
      sentMany: '{{count}} Nachrichten gesendet.',
      partial:
        '{{sent}} gesendet. {{failed}} konnten nicht gesendet werden, weil sie inzwischen geändert wurden.',
      failed: 'Die Nachricht konnte nicht gesendet werden.',
      templatesFailed: 'Die Vorlagen konnten nicht geladen werden.',
      unfilled:
        'Im Text steht noch ein Platzhalter wie [Datum]. Ersetze ihn und sende dann erneut.',
      discard: {
        title: 'Nachricht verwerfen?',
        text: 'Dein Text wurde noch nicht gesendet und geht verloren.',
        confirm: 'Verwerfen',
        cancel: 'Weiterschreiben',
      },
      versionConflict:
        'Jemand hat die Bewerbung inzwischen geändert. Dein Text ist noch da. Prüfe den Stand und sende erneut.',
      invalidTransition:
        'Der Status der Bewerbung lässt diese Nachricht nicht mehr zu. Sie wurde nicht gesendet.',
      withdrawn:
        'Die Bewerbung wurde zurückgezogen. Die Nachricht wurde nicht gesendet.',
      changedMeanwhile:
        'Die Bewerbung wurde inzwischen geändert. Die Nachricht wurde nicht gesendet.',
      skipped:
        '{{count}} von {{total}} werden übersprungen, weil ihr Status das nicht zulässt, zum Beispiel schon abgesagt.',
      notPossible: 'Im Status «{{status}}» ist diese Nachricht nicht möglich.',
      skippedBadge: 'Wird übersprungen',
      INVITATION: {
        short: 'Einladung',
        plural: 'Einladungs',
        title: 'Einladung schreiben',
        quickTitle: 'Einladung senden',
        send: 'Einladung senden',
        sendQuick: 'Einladung jetzt senden',
        sendMany: '{{count}} Einladungen senden',
        confirmTitle: '{{count}} Einladungen senden?',
        confirmText:
          'Jede der {{count}} Personen erhält eine eigene Nachricht. Der Status wechselt auf «Eingeladen». Gesendete E-Mails lassen sich nicht zurückholen.',
      },
      ACCEPTANCE: {
        short: 'Zusage',
        plural: 'Zusage',
        title: 'Zusage schreiben',
        quickTitle: 'Schnellzusage senden',
        send: 'Zusage senden',
        sendQuick: 'Zusage jetzt senden',
        sendMany: '{{count}} Zusagen senden',
        confirmTitle: '{{count}} Zusagen senden?',
        confirmText:
          'Jede der {{count}} Personen erhält eine eigene Nachricht. Der Status wechselt auf «Zugesagt». Gesendete E-Mails lassen sich nicht zurückholen.',
      },
      REJECTION: {
        short: 'Absage',
        plural: 'Absage',
        title: 'Absage schreiben',
        quickTitle: 'Schnellabsage senden',
        send: 'Absage senden',
        sendQuick: 'Absage jetzt senden',
        sendMany: '{{count}} Absagen senden',
        confirmTitle: '{{count}} Absagen senden?',
        confirmText:
          'Jede der {{count}} Personen erhält eine eigene Nachricht. Der Status wechselt auf «Abgesagt». Gesendete E-Mails lassen sich nicht zurückholen.',
      },
      saveTemplate: {
        open: 'Als Vorlage speichern',
        title: 'Als Vorlage speichern',
        fullTitle: 'Du hast schon 3 {{kind}}-Vorlagen',
        lead: 'Speichere den Text, um ihn später wiederzuverwenden.',
        fullLead:
          'Pro Art gibt es 3 eigene Vorlagen und 3 Vorlagen der Schule. Wähle eine, die du ersetzen möchtest.',
        name: 'Name der Vorlage',
        nameHint:
          'Namen und Stellenbezeichnung passt Bildigsnetz beim nächsten Mal automatisch an.',
        who: 'Wer soll die Vorlage nutzen können?',
        personal: 'Nur ich',
        personalSub: 'Erscheint unter «Meine Vorlagen»',
        school: 'Die ganze Schule',
        schoolSub:
          'Erscheint bei allen unter «Vorlagen der Schule». Nur Besitzer, Admin und HR',
        replace: 'Welche Vorlage möchtest du ersetzen?',
        save: 'Speichern',
        replaceSave: 'Ersetzen und speichern',
        saved: 'Vorlage gespeichert.',
        forbidden:
          'Vorlagen der Schule können nur Besitzer, Admin und HR speichern.',
        limit: 'Es gibt schon 3 Vorlagen dieser Art.',
        failed: 'Die Vorlage konnte nicht gespeichert werden.',
      },
    },
    actions: {
      label: 'Aktionen',
      menu: 'Aktionen für {{name}}',
      invite: 'Einladen',
      inviteSub: 'Gespräch, Probelektion, Schnuppertag',
      accept: 'Zusagen',
      acceptSub: 'Persönliche Nachricht',
      quickAccept: 'Schnellzusage',
      quickSub: 'Standardtext, sofort gesendet',
      onlySingle: 'Nur für eine einzelne Bewerbung möglich',
      reject: 'Absagen',
      rejectSub: 'Persönliche Nachricht',
      quickReject: 'Schnellabsage',
      tooMany: 'Höchstens 50 auf einmal.',
    },
    initiative: {
      title: 'Initiativbewerbungen',
      subtitle: 'Bewerbungen ohne konkrete Stelle',
      link: 'Initiativbewerbungen',
    },
  },
  applyForm: {
    backJob: 'Zurück zur Stelle',
    backSchool: 'Zurück zum Schulprofil',
    forJob: 'Deine Bewerbung für',
    forInitiative: 'Deine Initiativbewerbung an',
    badge: {
      fulltime: 'Festanstellung',
      substitute: 'Stellvertretung',
      temporary: 'Befristete Anstellung',
      initiative: 'Initiativbewerbung',
    },
    hello: {
      member: 'Hallo {{name}}, fast geschafft',
      memberInitiative: 'Hallo {{name}}, schön, dass du da bist',
      guest: 'Bewerbung als Gast',
      guestInitiative: 'Schön, dass du da bist!',
    },
    intro: {
      member:
        'Deine Angaben aus dem Profil sind eingesetzt. Ergänze, was fehlt, und sende ab.',
      guest: 'Ohne Konto, direkt bei der Schule.',
      initiative:
        'Auch ohne ausgeschriebene Stelle freut sich die Schule, dich kennenzulernen.',
    },
    progress: '{{done}} von {{total}} Schritten erledigt',
    progressLabel: 'Fortschritt der Bewerbung',
    duration: {
      member: 'Dauert etwa 2 Minuten',
      guest: 'Dauert etwa 4 Minuten',
    },
    requiredNote: 'Pflichtfelder sind mit * markiert.',
    stepDone: ', Schritt {{n}} erledigt',
    stepOpen: ', Schritt {{n}} von {{total}}',
    step: {
      personal: {
        job: 'Personalien',
        initiative: 'Über dich',
      },
      qualification: {
        job: 'Deine Qualifikation',
        initiative: 'Deine Qualifikation',
      },
      message: {
        job: 'Nachricht an die Schule',
        initiative: 'Erzähl der Schule von dir',
      },
      docs: {
        job: 'Deine Unterlagen',
        initiative: 'Deine Unterlagen',
      },
      confirm: {
        job: 'Bestätigungen',
        initiative: 'Bestätigungen',
      },
    },
    personal: {
      memberNote:
        'Die Angaben gelten nur für diese Bewerbung. Dein Profil bleibt unverändert.',
      profileName: 'Name aus deinem Profil',
      salutation: 'Anrede',
      birthDate: 'Geburtsdatum',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      street: 'Strasse und Nr.',
      postalCode: 'PLZ',
      city: 'Ort',
    },
    salutation: {
      FEMALE: 'Frau',
      MALE: 'Herr',
      NONE: 'Keine Angabe',
    },
    qualification: {
      help: 'Für den Beruf, auf den du dich bewirbst. Die Schule kann danach sortieren.',
      DIPLOMA: {
        title: 'Diplomiert',
        text: 'Abgeschlossene Ausbildung oder anerkanntes Diplom für diesen Beruf.',
      },
      BASE_YEAR_COMPLETED: {
        title: 'Erfolgreiches Basisjahr',
        text: 'In Ausbildung, das erste Ausbildungsjahr ist erfolgreich abgeschlossen.',
      },
      TRAINING: {
        title: 'Am Anfang der Ausbildung',
        text: 'In Ausbildung, das erste Ausbildungsjahr läuft noch.',
      },
      NON_SPECIALIST: {
        title: 'Fachfremd',
        text: 'Ohne Ausbildung in diesem Beruf, zum Beispiel Quereinstieg.',
      },
    },
    message: {
      label: 'Motivation oder Bewerbungsschreiben',
      placeholder: 'Liebes Team …',
      help: {
        job: 'Ein paar persönliche Sätze genügen, oder füge dein Bewerbungsschreiben ein.',
        initiative:
          'Was begeistert dich, was bringst du mit? Ein paar Sätze genügen.',
      },
    },
    docs: {
      memberNote:
        'Aus deinem Bewerbungsdossier übernommen. Du kannst Dateien für diese Bewerbung entfernen oder ergänzen.',
      cv: 'Lebenslauf',
      cvUpload: 'Lebenslauf hochladen',
      diplomas: 'Diplome und Zertifikate',
      tandemCv: '2. Lebenslauf (nur bei Tandem-Bewerbung)',
      tandemCvUpload: 'Lebenslauf 2 hochladen',
      references: 'Arbeitszeugnisse und Weiteres',
      filesUpload: 'Dateien hochladen',
      formats: 'PDF, DOC oder DOCX, je höchstens 5 MB.',
    },
    confirm: {
      terms:
        'Meine Angaben sind korrekt und ich bin einverstanden mit den AGB und der Datenschutzerklärung.',
      criminalRecord:
        'Ich bestätige, dass keine noch nicht gelöschten Vorstrafen in meinem Strafregister bestehen, kein laufendes Strafverfahren gegen mich besteht und kein formelles oder faktisches Berufsverbot gegen mich vorliegt (weder in der Schweiz noch im Ausland).',
      required: 'Beide Bestätigungen sind nötig.',
    },
    footNote: {
      member:
        'Du bekommst eine Bestätigung per E-Mail. Den Stand siehst du unter «Meine Bewerbungen».',
      guest: 'Du bekommst eine Bestätigung per E-Mail.',
    },
    cancel: 'Abbrechen',
    send: 'Bewerbung absenden',
    sendInitiative: 'Initiativbewerbung absenden',
    failed: {
      alreadyApplied:
        'Du hast dich auf diese Stelle bereits beworben. Solange diese Bewerbung offen ist, ist keine zweite möglich.',
      closed: 'Diese Stelle nimmt keine Bewerbungen mehr entgegen.',
      notPublished: 'Diese Stelle ist nicht mehr ausgeschrieben.',
      notYetPublished: 'Diese Stelle ist noch nicht ausgeschrieben.',
      expired: 'Die Bewerbungsfrist für diese Stelle ist abgelaufen.',
      disabled: 'Bewerbungen sind im Moment nicht möglich.',
      fileUnreadable:
        'Eine Datei konnte nicht gelesen werden. Bitte lade sie erneut hoch.',
      fileNotOwned:
        'Eine Datei gehört nicht zu deinem Konto. Bitte lade sie neu hoch.',
      offline:
        'Keine Verbindung. Bitte prüfe deine Internetverbindung und versuche es erneut.',
      generic: 'Leider ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    },
    error: {
      salutation: 'Bitte wähle eine Anrede.',
      birthDate: 'Bitte gib dein Geburtsdatum an.',
      birthDateRange: 'Bitte prüfe das Geburtsdatum.',
      firstName: 'Bitte gib deinen Vornamen an.',
      lastName: 'Bitte gib deinen Nachnamen an.',
      email: 'Bitte gib deine E-Mail-Adresse an.',
      emailFormat:
        'Bitte gib eine gültige E-Mail-Adresse ein, zum Beispiel name@beispiel.ch.',
      phone:
        'Bitte gib deine Telefonnummer an, damit die Schule dich erreichen kann.',
      street: 'Bitte gib Strasse und Nummer an.',
      postalCode: 'Bitte gib die PLZ an.',
      city: 'Bitte gib den Ort an.',
      qualification: 'Bitte wähle, wo du in deinem Beruf stehst.',
      message: 'Bitte schreib der Schule ein paar Sätze.',
    },
  },
  applyChoice: {
    title: {
      job: 'Deine Bewerbung',
      initiative: 'Deine Initiativbewerbung',
    },
    back: {
      job: 'Zurück zur Stelle',
      initiative: 'Zurück zur Schule',
    },
    question: 'Wie möchtest du dich bewerben?',
    profile: {
      title: 'Mit Profil bewerben',
      recommended: 'Empfohlen',
      text: 'Erstelle in einer Minute dein kostenloses Profil. Das bringt dir:',
      signup: 'Kostenlos registrieren und bewerben',
      hasAccount: 'Bereits ein Konto?',
      login: 'Anmelden und fortfahren',
    },
    guest: {
      title: 'Als Gast bewerben',
      text: {
        job: 'Ohne Konto, nur für diese Stelle. Du lädst deine Unterlagen direkt hoch.',
        initiative:
          'Ohne Konto, nur für diese Schule. Du lädst deine Unterlagen direkt hoch.',
      },
      upload: 'Lebenslauf und Unterlagen für diese Bewerbung hochladen',
      again: 'Für weitere Bewerbungen lädst du alles erneut hoch',
      start: 'Als Gast fortfahren',
    },
  },
  applicationSent: {
    title: 'Bewerbung gesendet',
    titleInitiative: 'Initiativbewerbung gesendet',
    textJobGuest:
      'Deine Bewerbung als {{job}} ist bei {{school}} angekommen. Die Bestätigung geht an {{email}}.',
    textJobMember:
      'Deine Bewerbung als {{job}} ist bei {{school}} angekommen. Den Stand siehst du unter «Meine Bewerbungen».',
    textInitiativeGuest:
      'Deine Initiativbewerbung ist bei {{school}} angekommen. Die Bestätigung geht an {{email}}.',
    textInitiativeMember:
      'Deine Initiativbewerbung ist bei {{school}} angekommen. Den Stand siehst du unter «Meine Bewerbungen».',
    close: 'Schliessen',
    later: 'Nein, danke',
    ok: 'Fertig',
    finishProfile: 'Profil fertigstellen',
    moreJobs: 'Weitere Stellen ansehen',
    toApplications: 'Zu meinen Bewerbungen',
    offer: {
      title: 'Dein Profil ist schon fast fertig',
      text: 'Deine Angaben sind übernommen. Es fehlen nur zwei Schritte, etwa eine Minute.',
      stepsLabel: 'Profil erstellen',
      stepTaken: 'Angaben und Unterlagen übernommen',
      stepEmail: 'E-Mail-Adresse bestätigen',
      stepPassword: 'Passwort festlegen',
      done: 'erledigt',
      benefitsTitle: 'Das bringt dir dein Profil',
      benefitOneClick:
        'Mit einem Klick bewerben, deine Unterlagen sind gespeichert',
      benefitStatus: 'Deinen Bewerbungsstatus live sehen',
      benefitChat:
        'Mit der Schule chatten, mit Push-Benachrichtigung aufs Handy',
      benefitAlert: 'Passende Stellen per Stellenabo',
    },
  },
  guestOnboarding: {
    title: 'Fast geschafft, {{name}}',
    text: 'Deine E-Mail-Adresse ist bestätigt. Es fehlt nur noch deine Berufsbezeichnung.',
    later: 'Verfügbarkeit und Profilbild ergänzt du später in deinem Profil.',
    submit: 'Profil erstellen',
    qualificationMissing:
      'Bitte beantworte bei jeder Berufsbezeichnung die Frage zur Qualifikation.',
  },
  guestWelcome: {
    title: 'Willkommen bei Bildigsnetz',
    text: 'Dein Profil ist bereit. Deine Bewerbung findest du unter «Meine Bewerbungen».',
    applications: 'Meine Bewerbungen',
    jobs: 'Offene Stellen ansehen',
    close: 'Schliessen',
    hintTitle:
      'Damit Schulen dich finden: Ergänze Verfügbarkeit und Profilbild',
    hintText: 'Es fehlen nur noch wenige Angaben.',
    hintAction: 'Profil ergänzen',
  },
  initiativeApply: {
    cardTitle: 'Initiativbewerbung',
    cardText:
      'Keine passende Stelle dabei? Bewirb dich initiativ bei {{school}}.',
    start: 'Initiativbewerbung starten',
    noPostingNeeded: 'keine ausgeschriebene Stelle nötig',
    intro:
      'Auch ohne ausgeschriebene Stelle freut sich die Schule, dich kennenzulernen.',
    missing: 'Diese Schule haben wir nicht gefunden.',
    allSchools: 'Alle Schulen',
    fileMissing:
      'Eine Datei konnte nicht gelesen werden. Bitte lade sie erneut hoch.',
    listHint: 'Bewerbung ohne ausgeschriebene Stelle',
    error: {
      alreadyApplied:
        'Du hast dich hier bereits initiativ beworben. Solange diese Bewerbung offen ist, ist keine zweite möglich.',
      disabled: 'Initiativbewerbungen sind im Moment nicht möglich.',
      notPublished:
        'Diese Schule nimmt zurzeit keine Initiativbewerbungen entgegen.',
      generic: 'Leider ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    },
  },
};
